import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Badge from '@material-ui/core/Badge';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import KundSection from './KundSection'
import KontakterSection from './KontakterSection'
import ArtiklarSection from './ArtiklarSection'
import AvtalSection from './AvtalSection'
import ProspektSection from './ProspektSection'
import OrderSection from './OrderSection'
import EventSection from './EventSection'
import ESigneringSection from './ESigneringSection'
import FaktureringSection from './FaktureringSection'
import ArendeSection from './ArendeSection'
import ProjektSection from './ProjektSection'
import AktiviteterSection from './AktiviteterSection'
import OffertSection from './OffertSection'
import {isUndefined } from 'lodash'
import IntlMessages from 'util/IntlMessages';
function RapportSection(props) {
    const [Value,setValue] = React.useState(0)
    const handleChange = (event,newValue)=>{
        setValue(newValue);
    }
    console.log(props.Chips,"props.Chips")
    return (
        <div  style={{padding: "0px"}} > 
            <AppBar className="bg-primary" position="static">
                <Tabs  value={Value} onChange={handleChange} 
                indicatorColor="primary"
                scrollable 
                variant="scrollable"
                scrollButtons="auto">
                <Tab className="tab" label={
                    props.Chips.some(item=>item.MetaN.includes("Kund_"))?
                    <Badge badgeContent={props.Chips.filter(item=>item.MetaN.includes("Kund_") && item.isSwitch === true).filter(item=>!item.MetaN.includes("_Kund_")).length} color="secondary"><IntlMessages id="Table.Customer"/></Badge>
                    :"Kund"
                } disabled={props.DisabledArr.Kund}/>
                <Tab className="tab" label={
                    props.Chips.some(item=>item.MetaN.includes("Kontaktperson_"))?
                    <Badge badgeContent={props.Chips.filter(item=>item.MetaN.includes("Kontaktperson_") && item.isSwitch === true).length} color="secondary">Kontakter</Badge>
                    :"Kontakter"
                } disabled={props.DisabledArr.Kontakter}/>
                <Tab className="tab" label={ props.Chips.some(item=>item.MetaN.includes("Artikel_"))?
                    <Badge badgeContent={props.Chips.filter(item=>item.MetaN.includes("Artikel_") && item.isSwitch === true).length} color="secondary"><IntlMessages id="Products"/></Badge>
                    :"Artiklar"
                } disabled={props.DisabledArr.Artiklar}/>
                <Tab className="tab" label={ props.Chips.some(item=>item.MetaN.includes("Avtal_") )?
                    <Badge badgeContent={props.Chips.filter(item=>item.MetaN.includes("Avtal_") && item.isSwitch === true).length} color="secondary"><IntlMessages id="Agreement"/></Badge>
                    :"Avtal"
                } disabled={props.DisabledArr.Avtal}/>
                <Tab className="tab" label={props.Chips.some(item=>item.MetaN.includes("Prospekt_"))?
                    <Badge badgeContent={props.Chips.filter(item=>item.MetaN.includes("Prospekt_") && item.isSwitch === true).length} color="secondary"><IntlMessages id="Prospectus"/></Badge>
                    :"Prospekt"
                } disabled={props.DisabledArr.Prospekt}/>
                <Tab className="tab" label={props.Chips.some(item=>item.MetaN.includes("Order_"))?
                    <Badge badgeContent={props.Chips.filter(item=>item.MetaN.includes("Order_") && item.isSwitch === true).length} color="secondary"><IntlMessages id="Order"/></Badge>
                    :"Order"
                } disabled={props.DisabledArr.Order}/>                
                <Tab className="tab" label={props.Chips.some(item=>item.MetaN.includes("Event_"))?
                    <Badge badgeContent={props.Chips.filter(item=>item.MetaN.includes("Event_") && item.isSwitch === true).length} color="secondary"><IntlMessages id="DashBoard.Customized.Booking"/></Badge>
                    :"Möte"
                } disabled={props.DisabledArr.Event}/>
                <Tab className="tab" label={props.Chips.some(item=>item.MetaN.includes("Esignering_"))?
                    <Badge badgeContent={props.Chips.filter(item=>item.MetaN.includes("Esignering_") && item.isSwitch === true).length} color="secondary"><IntlMessages id="E-signing"/></Badge>
                    :"E-signering"
                } disabled={props.DisabledArr.Esignering}/>
                <Tab className="tab" label={props.Chips.some(item=>item.MetaN.includes("Faktura_"))?
                    <Badge badgeContent={props.Chips.filter(item=>item.MetaN.includes("Faktura_") && item.isSwitch === true).length} color="secondary"><IntlMessages id="Label.invoicing"/></Badge>
                    :"Fakturering"
                } disabled={props.DisabledArr.Fakturering}/>
                <Tab className="tab" label={props.Chips.some(item=>item.MetaN.includes("Arende_"))?
                    <Badge badgeContent={props.Chips.filter(item=>item.MetaN.includes("Arende_") && item.isSwitch === true).length} color="secondary"><IntlMessages id="Errand"/></Badge>
                    :"Ärende"
                } disabled={props.DisabledArr.Arende}/>
                <Tab className="tab" label={props.Chips.some(item=>item.MetaN.includes("Projekt_"))?
                    <Badge badgeContent={props.Chips.filter(item=>item.MetaN.includes("Projekt_") && item.isSwitch === true).length} color="secondary"><IntlMessages id="Project"/></Badge>
                    :"Projekt"
                } disabled={props.DisabledArr.Projekt}/>
                <Tab className="tab" label={props.Chips.some(item=>item.MetaN.includes("Aktivitet_"))?
                    <Badge badgeContent={props.Chips.filter(item=>item.MetaN.includes("Aktivitet_") && item.isSwitch === true).length} color="secondary"><IntlMessages id="Activities"/></Badge>
                    :"Aktiviteter"
                } disabled={props.DisabledArr.Aktiviteter}/>
                <Tab className="tab" label={props.Chips.some(item=>item.MetaN.includes("Offert_"))?
                    <Badge badgeContent={props.Chips.filter(item=>item.MetaN.includes("Offert_") && item.isSwitch === true).length} color="secondary"><IntlMessages id="Offer"/></Badge>
                    :"Offert"
                } disabled={props.DisabledArr.Offert}/>
                </Tabs>
            </AppBar>
            <div style={{padding: "10px"}}>
            {Value === 0 &&<div><KundSection Chips={props.Chips} onChangeMstate={props.onChangeChips}/></div>}
            {Value === 1 &&<div><KontakterSection Chips={props.Chips} onChangeMstate={props.onChangeChips}/></div>}
            {Value === 2 &&<div><ArtiklarSection Chips={props.Chips} onChangeMstate={props.onChangeChips}/></div>}
            {Value === 3 &&<div><AvtalSection Chips={props.Chips} onChangeMstate={props.onChangeChips}/></div>}
            {Value === 4 &&<div><ProspektSection Chips={props.Chips} onChangeMstate={props.onChangeChips}/></div>}
            {Value === 5 &&<div><OrderSection Chips={props.Chips} onChangeMstate={props.onChangeChips}/></div>}
            {Value === 6 &&<div><EventSection Chips={props.Chips} onChangeMstate={props.onChangeChips}/></div>}
            {Value === 7 &&<div><ESigneringSection Chips={props.Chips} onChangeMstate={props.onChangeChips}/></div>}
            {Value === 8 &&<div><FaktureringSection Chips={props.Chips} onChangeMstate={props.onChangeChips}/></div>}
            {Value === 9 &&<div><ArendeSection Chips={props.Chips} onChangeMstate={props.onChangeChips}/></div>}
            {Value === 10 &&<div><ProjektSection Chips={props.Chips} onChangeMstate={props.onChangeChips}/></div>}
            {Value === 11 &&<div><AktiviteterSection Chips={props.Chips} onChangeMstate={props.onChangeChips}/></div>}
            {Value === 12 &&<div><OffertSection Chips={props.Chips} onChangeMstate={props.onChangeChips}/></div>}
            </div>
        </div>
    );
}

export default RapportSection;